module.exports = __webpack_public_path__ + "img/qualification-icon.e0b7e5b3.svg";